<template>
  <div class="content-custom-pj" v-if="this.$store.get('systems@ApiKey')">
    <div>{{ this.chkUserModulRightCheck() }}</div>
    <div v-if="!ModulRightCheck">
      <b-alert show variant="danger"
        >ไม่มีสิทธิเข้าใช้งาน EverRefer To HOSxP</b-alert
      >
    </div>

    <div v-if="ModulRightCheck">
      <h4>
        <v-icon name="trending-down" class="icon-custom1"></v-icon> EverRefer To
        HOSxP
      </h4>

      <b-alert show variant="primary" class="margin-bottom">
        <b-form id="form-search-scan-file" @submit="this.SearchVisitSubmit">
          <b-row>
            <b-col lg="2" class="margin-bottom-lg">
              <b-input-group size="sm">
                <b-input-group-prepend is-text
                  ><b>Visit วันที่</b></b-input-group-prepend
                >
                <template v-slot:append>
                  <date-picker
                    v-model="form.visit_date"
                    :lang="lang"
                    :first-day-of-week="1"
                    format="DD/MM/YYYY"
                    style="width:120px;"
                  ></date-picker>
                </template>
              </b-input-group>
            </b-col>

            <b-col lg="3" class="margin-bottom-lg">
              <b-input-group size="sm">
                <b-input-group-prepend is-text
                  ><b>CID/HN</b></b-input-group-prepend
                >
                <b-form-input
                  id="hn"
                  name="hn"
                  type="number"
                  v-model="form.cidhn"
                  maxlength="13"
                  oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0,this.maxLength);"
                ></b-form-input>
                <b-input-group-append>
                  <b-button
                    type="submit"
                    id="bt-search-patient-visit"
                    variant="info"
                    >Search</b-button
                  >
                </b-input-group-append>
              </b-input-group>
            </b-col>
          </b-row>
        </b-form>
      </b-alert>
      <div>
        <EverReferVisitData
          v-bind:my-search-status="this.SearchStatus"
          v-bind:my-vstdate="this.VisitDateSelect"
          v-bind:my-hn="this.HnSelect"
          v-bind:my-cid="this.CidSelect"
        >
        </EverReferVisitData>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import store from "@/store/store";
import axios from "axios";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

import MenuIcon from "vue-material-design-icons/Menu.vue";
import RefreshIcon from "vue-material-design-icons/Refresh.vue";
import ReferLookup from "@/models/patientEMRs/ReferLookup";

import EverReferVisitData from "@/components/OPDs/EverReferToHOSxP/EverReferVisitData";

Vue.component("EverReferVisitData", EverReferVisitData);

Vue.component("menu-icon", MenuIcon);
Vue.component("refresh-icon", RefreshIcon);

@Component({
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      ModulRightCheck: false,
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        }
      },
      form: {
        visit_date: new Date(),
        cidhn: ""
      },
      CidSelect: "",
      HnSelect: "",
      VisitDateSelect: "",
      SearchStatus: false
    };
  },
  component: {
    store,
    axios,
    thaiDatetime,
    pjFunctions,
    ReferLookup
  },
  mounted() {
    this.loadDataLookup();
  },
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
    setTimeout(() => {
      // document.getElementById("bt-search-patient-visit").click();
    }, 500);
  },
  watch: {},
  methods: {
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },

    chkUserModulRightCheck() {
      if (this.$store.get("systems@LoginStatus")) {
        if (
          this.pjFunctionsFc.UserModulRightCheck(
            this.$store.get("systems@LoginData").accessright,
            "Admin"
          ) ||
          this.pjFunctionsFc.UserHOSxPRightCheck(
            this.$store.get("systems@LoginData").hos_accessright,
            "ADMIN"
          ) ||
          this.pjFunctionsFc.UserModulRightCheck(
            this.$store.get("systems@LoginData").accessright,
            "AdminOPDScan"
          )
        ) {
          this.ModulRightCheck = true;
        } else {
          this.ModulRightCheck = false;
        }
      } else {
        this.ModulRightCheck = false;
      }
    },
    loadDataLookup() {
      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "ReferInLookup", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey")
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            ReferLookup.delete({
              where(record) {
                return record.id != "";
              }
            });

            let data = [];
            data.push({
              id: "referin",
              refer_lookup_type: "referin",
              datas: ScrObj.output.result
            });

            ReferLookup.insertOrUpdate({
              data
            });
          } else {
            if (ScrObj.output.ErrorMessage === "Data Not Found") {
              ReferLookup.delete({
                where(record) {
                  return record.id != "";
                }
              });
            }
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("ReferLookup : " + ScrObj.output);
        })
        .finally(function() {
          // ScrObj.getDataScanType();
        });
    },
    SearchVisitSubmit(evt) {
      evt.preventDefault();

      this.SearchStatus = false;

      let FormData = this.form;

      if (FormData.cidhn.trim().length == 13) {
        this.CidSelect = FormData.cidhn.trim();
      } else {
        this.CidSelect = "";
      }

      if (FormData.cidhn.trim().length == 9) {
        this.HnSelect = FormData.cidhn.trim();
      } else {
        this.HnSelect = "";
      }

      this.VisitDateSelect = this.thaiDatetimeFc.DateTimeToStrDate(
        FormData.visit_date
      );

      if (this.CidSelect == "" && this.HnSelect == "") {
        this.SearchStatus = false;
        alert("CID/HN ไม่ถูกต้อง");
      } else {
        setTimeout(() => {
          this.SearchStatus = true;
        }, 500);
      }
    }
  }
})
export default class EverReferToHOSxP extends Vue {}
</script>


<style lang="scss">
</style>
